import { gql as t } from "@apollo/client";
import { PublicAccountFragment as i, PublicInvitationFragment as n } from "../fragment/account.js";
const r = t`
  query GetBelievedInviter($id: String!, $address: String!) {
    getAdeptusCampaignInviter(
      input: { campaignID: $id, walletAddress: $address }
    ) {
      account {
        ...PublicAccount
      }
      accountInvitation {
        ...PublicInvitation
      }
    }
  }

  ${i}
  ${n}
`;
export {
  r as default
};
//# sourceMappingURL=getBelievedInviter.js.map
